// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
// @ts-ignore
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './notification_item.module.less';
import {i_notification_item_props}
    from '../../../../oculus/pub/ui/dashboard/notification_item';
export type NotificationVariant = 'info' | 'bonus' | 'warning' | 'error';
import Icon_close from '../../../pub/img/icons/16/close.svg';
import {Button} from '../../../../oculus/pub/lib/button';
export const Notification_item =(
    {
        title,
        type,
        message,
        time,
        button_text,
        button_link,
        read,
        icon_url,
        variant,
        open_in_new_tab,
        on_delete
    }: i_notification_item_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.notification_item,
      !read && styles.notification_item_new)}>
      {!read && <p className={cn(theme.semi, theme.p12, styles.badge)}>
        New</p>}
      <div className={styles.notification}>
        {type && <div className={cn(styles.icon_block,
          styles[variant])}>
            <div
              className={cn(styles.icon_img, styles[variant])}
              style={{
                WebkitMaskImage: `url(${icon_url})`,
                maskImage: `url(${icon_url})`,
              }}
            />
          </div>
        }
        <div className={styles.notification_item_content}>
          <div className={styles.notification_title}>
            <p className={cn(theme.color_n700, theme.med, theme.p16)}>
              {title}</p>
            {read && <div onClick={on_delete}>
              <Icon_close/>
            </div>}
          </div>
          <p className={cn(theme.p14, theme.color_n700,
            styles.notification_message)}>
            {message}</p>
          <div className={styles.time}>
            {button_text && <Button
              caption={button_text}
              color='primary'
              size='s'
              fit
              as_external
              target={open_in_new_tab ? '_blank' : '_self'}
              to={button_link?.startsWith('http') ?
                button_link : `/${button_link}`}
              cls={cn(styles.btn, theme.med, theme.p14)}/>}
            <p className={cn(theme.p12, styles.time_text, theme.color_n300,)}>
              {time}</p>
          </div>
        </div>
      </div>
    </div>;
};
